import _ from "lodash";
import React from "react";
import isEqual from 'react-fast-compare';
import { StyleSheet } from 'react-native';
import { ThemedSelectStyles } from 'styles/components/atoms/ThemedSelect';
import Select from 'theme/Select';
import i18n from "utils/i18n";

const ThemedSelect = ({ style = {}, options = [], selected, select, placeholder, disabled = false, label, caption, search = false, testID, accessibilityLabel }) => {
	
	if( typeof placeholder === 'undefined' ) {
		placeholder = i18n.t('form.select.placeholder')
	}
	
	const onSelect = ( value ) => {
		if( select && _.isFunction( select ) ) {
			select( value );
		}
	}
	
	const selectStyle = [
		ThemedSelectStyles.select,
		style,
	]
	
	return (
		<Select
			style={ selectStyle }
			placeholder={ placeholder }
			disabled={ disabled }
			search={ search }
			testID={ testID }
			accessibilityLabel={ accessibilityLabel ?? label }
			value={ selected }
			onSelect={ onSelect.bind( this ) }
			data={ options }
		/>
	)
}

const styles = StyleSheet.create({
	selectItem: {
		flex: 1,
	}
});

export default React.memo( ThemedSelect, isEqual );
